import { ArrowRight, ArrowLeft, Users, Images, Camera, Palette, CreditCard, ShieldCheck } from 'lucide-react';
import { NAV } from './Sidebar';

const QUICK = [
  { id: 'attendees', icon: Users, title: 'Attendees', body: 'Who registered, their album links, signature status and link requests.' },
  { id: 'photos', icon: Images, title: 'Photos', body: 'Every upload in this event, who shot it, and how many guests matched.' },
  { id: 'photographers', icon: Camera, title: 'Photographers', body: 'Create expiring upload links so your team shoots straight into this folder.' },
  { id: 'branding', icon: Palette, title: 'Branding', body: 'Welcome copy, public portal link and hiding the Spotfie footer.' },
  { id: 'billing', icon: CreditCard, title: 'Billing', body: 'Free vs Pro Event Pass, one-time payment, receipts.' },
  { id: 'privacy', icon: ShieldCheck, title: 'Privacy', body: 'Signature retention, close-event purge and security measures.' },
];

export const QuickNav = ({ onTab }) => (
  <div data-testid="quick-nav">
    <p className="label mb-3">Explore this workspace</p>
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4">
      {QUICK.map(({ id, icon: Icon, title, body }, i) => (
        <button
          key={id}
          data-testid={`quick-nav-${id}`}
          onClick={() => onTab(id)}
          className={`card card-hover p-5 text-left group fade-up fade-up-delay-${Math.min(i, 4)}`}
        >
          <div className="flex items-center justify-between mb-3">
            <span className="w-9 h-9 border-2 border-line text-cyan flex items-center justify-center group-hover:bg-cyan group-hover:text-ink group-hover:border-cyan transition-colors"><Icon className="w-4 h-4" /></span>
            <ArrowRight className="w-4 h-4 text-slate-500 group-hover:text-cyan group-hover:translate-x-1 transition-all" />
          </div>
          <p className="font-display font-bold uppercase tracking-wider text-sm text-white">{title}</p>
          <p className="text-xs text-slate-400 mt-1 leading-relaxed">{body}</p>
        </button>
      ))}
    </div>
  </div>
);

export const SectionNav = ({ tab, onTab }) => {
  const idx = NAV.findIndex((n) => n.id === tab);
  const prev = NAV[idx - 1];
  const next = NAV[idx + 1];
  return (
    <div className="flex items-center justify-between gap-3 pt-6 border-t-2 border-line" data-testid="section-nav">
      {prev ? (
        <button data-testid="section-prev-btn" onClick={() => onTab(prev.id)} className="btn-ghost !py-2.5">
          <ArrowLeft className="w-4 h-4" /> {prev.label}
        </button>
      ) : <span />}
      {next ? (
        <button data-testid="section-next-btn" onClick={() => onTab(next.id)} className="btn-secondary !py-2.5 !px-4 !text-xs">
          Next: {next.label} <ArrowRight className="w-4 h-4" />
        </button>
      ) : (
        <button data-testid="section-next-btn" onClick={() => onTab('overview')} className="btn-secondary !py-2.5 !px-4 !text-xs">
          Back to Overview <ArrowRight className="w-4 h-4" />
        </button>
      )}
    </div>
  );
};
